import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

export const getSellerDetails = createHttpEndpoint<GetSellerDetails>({
  method: 'GET',
  operationId: 'getSellerDetails',
  path: '/product-page/products/:id/listings/:listingId/legal-details',
})

export type GetSellerDetails = HttpResponsePayload<{
  manufacturer?: {
    companyName: string
    brand: string
    email: string
    address: string
  }
  responsibleOperator?: {
    businessName: string
    addressLine1: string
    addressLine2: string
    postalCode: string
    city: string
    phone: string
    email: string
    website: string
  }
  merchant?: {
    sellerSinceDate: string
    link: string
  }
}>
